import { render, staticRenderFns } from "./dialog_batchAdd.vue?vue&type=template&id=453af793&scoped=true&"
import script from "./dialog_batchAdd.vue?vue&type=script&lang=js&"
export * from "./dialog_batchAdd.vue?vue&type=script&lang=js&"
import style0 from "./dialog_batchAdd.vue?vue&type=style&index=0&id=453af793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453af793",
  null
  
)

export default component.exports